import {useEffect, useState} from 'react'
import viewIcon from '../../../../../../media/stakeholders/ic-view.svg'
import deleteIcon from '../../../../../../media/stakeholders/ic-delete.svg'
import downloadIcon from '../../../../../../media/images/download.svg'
import {useIntl} from 'react-intl'
import ViewDocModal from './view-doc-modal'
import Skeleton from 'react-loading-skeleton'
import {getFileType, viewableFile} from '../../../../../core/_util'
import {downloadDocument} from '../../../founders-and-promoters/core/_requests'
import {useAuth} from '../../../../auth'
import {FileUpload} from '../../../../widgets/components/FileUpload'
import {toast} from 'react-toastify'
import {createDocument, deleteDocument} from '../../core/_requests'
import {allowedFileTypes, StakeholderModuleTypes} from '../../../../../core/_constants'
import {NoDataPage} from '../../../../resources/components/NoDataPage'
import {DeleteFileConfirmationModal} from '../../../components/delete-file-confirmation-modal'
import TagManager from 'react-gtm-module'
import {GTMEvent} from '../../../../../hooks/gtmHelpers'

export const IndividualAttatchments = ({
  stakeholdersDetails,
  loading,
  id,
  type,
  fetchTeamMemberDetails,
}: {
  stakeholdersDetails: any
  loading: boolean
  id: string
  type: StakeholderModuleTypes
  fetchTeamMemberDetails?: any
}) => {
  const {formatMessage} = useIntl()
  const [modelStatus, setModelStatus] = useState(false)
  const [selectedFileName, setSelectedFileName] = useState('')
  const [deleteLoading, setDeleteLoading] = useState(false)
  const [showDeleteModal, setDeleteShowModal] = useState(false)
  const [documentId, setDocumentId] = useState<any>('')
  const {companyId, currentUser} = useAuth()



  useEffect(() => {
    setFiles(stakeholdersDetails?.documents)
  }, [stakeholdersDetails])

  const [files, setFiles] = useState<any>([])

  const [isActive, setIsActive] = useState(false)

  const handleIsActive = (fileName: string) => {
    setSelectedFileName(fileName)
    setIsActive(!isActive)
  }

  const deleteFile = async () => {
    setDeleteLoading(true)
    try {
      const {
        data: {success},
      } = await deleteDocument(documentId, companyId!)
      if (success) {
        setFiles(files.filter((file: any) => file.documentId !== id))
        toast.success(formatMessage({id: 'Document deleted successfully'}))
        fetchTeamMemberDetails()
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.DeleteDocumentSuccessful,
            action: 'normal',
            metadata: {
              company_id: companyId,
              document_id: id,
              user_id: currentUser?.userId,
              email: currentUser?.email,
            },
          },
        })
      } else {
        toast.error(formatMessage({id: 'Document not deleted'}))
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.DeleteDocumentFailed,
            action: 'normal',
            metadata: {
              company_id: companyId,
              document_id: id,
              user_id: currentUser?.userId,
              email: currentUser?.email,
              error: formatMessage({id: 'Document not deleted'}),
            },
          },
        })
      }
    } catch (error) {
      console.log(error)
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.DeleteDocumentFailed,
          action: 'normal',
          metadata: {
            company_id: companyId,
            document_id: id,
            user_id: currentUser?.userId,
            email: currentUser?.email,
            error: error,
          },
        },
      })
    } finally {
      setDeleteLoading(false)
      setDeleteShowModal(false)
    }
  }

  const handleDownload = async (name: string) => {
    try {
      const {
        data: {success, data},
      } = await downloadDocument(name, companyId!)
      if (success) {
        const link = document.createElement('a')
        link.href = data
        link.setAttribute('download', name)
        document.body.appendChild(link)
        toast.success('Document downloaded successfully')
        link.click()
        link.remove()
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.DownloadDocumentSuccessful,
            action: 'normal',
            metadata: {
              company_id: companyId,
              document_id: id,
              user_id: currentUser?.userId,
              email: currentUser?.email,
              document_name: name,
            },
          },
        })
      }
    } catch (error) {
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.DownloadDocumentFailed,
          action: 'normal',
          metadata: {
            company_id: companyId,
            document_id: id,
            user_id: currentUser?.userId,
            email: currentUser?.email,
            document_name: name,
            error: error,
          },
        },
      })
    }
  }

  const onCreateDocument = async (fileId: number) => {
    if (!id) return
    try {
      const {
        data: {success},
      } = await createDocument([fileId], type, id, companyId!)
      if (success) {
        toast.success(formatMessage({id: 'Document uploaded successfully'}))
        fetchTeamMemberDetails()
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.DocumentUploadedSuccessful,
            action: 'normal',
            metadata: {
              company_id: companyId,
              document_id: id,
              user_id: currentUser?.userId,
              email: currentUser?.email,
              document_type: type,
              file_id: fileId,
            },
          },
        })
      } else {
        toast.error(formatMessage({id: 'Document not uploaded'}))
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.DocumentUploadedFailed,
            action: 'normal',
            metadata: {
              company_id: companyId,
              document_id: id,
              user_id: currentUser?.userId,
              email: currentUser?.email,
              document_type: type,
              file_id: fileId,
              error: formatMessage({id: 'Document not uploaded'}),
            },
          },
        })
      }
    } catch (error) {
      console.log(error)
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.DocumentUploadedFailed,
          action: 'normal',
          metadata: {
            company_id: companyId,
            document_id: id,
            user_id: currentUser?.userId,
            email: currentUser?.email,
            document_type: type,
            file_id: fileId,
            error: formatMessage({id: 'Document not uploaded'}),
          },
        },
      })
    }
  }

  return (
    <>
      <>
        <div className='bg-white rounded-2 px-md-4 px-2 py-4 position-relative mb-4'>
          <div className='d-md-flex justify-content-between w-100 align-items-center mb-4'>
            <h2 className='font-size-16'>{formatMessage({id: 'Attachments'})}</h2>
            <button
              className='btn btn-primary justify-content-center text-mute font-weight-400 font-size-13 height-36 d-flex align-items-center w-100 w-md-auto'
              onClick={() => setModelStatus(true)}
            >
              {formatMessage({id: 'Add Files'})}
            </button>
          </div>
          <div>
            {loading ? (
              <>
                <Skeleton
                  width={'100%'}
                  height={48}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
                <Skeleton
                  width={'100%'}
                  height={48}
                  baseColor='var(--kt-skeleton-bg-color)'
                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
              </>
            ) : (
              <div className='w-100'>
                <ul className='p-0 m-0'>
                  {files?.map((file: any) => (
                    <>
                      <li
                        key={file.documentId}
                        className='d-flex text-decoration-none justify-content-between mb-2 w-100 border border-1 p-2 rounded-2'
                      >
                        <div className='d-flex align-items-center gap-2'>
                          <img
                            src={getFileType(file.name)}
                            alt={file.name}
                            style={{height: '30px', width: '30px'}}
                          />

                          <p className='p-0 m-0'>{file?.name?.split('/').pop()}</p>
                        </div>

                        <div className='d-flex align-items-center gap-4'>
                          {viewableFile(file.name.toLowerCase()) && (
                            <button className='btn btn-secondry p-0 m-0'>
                              <img
                                src={viewIcon}
                                alt='View'
                                onClick={() => handleIsActive(file.name)}
                              />
                            </button>
                          )}

                          <button
                            className='btn btn-secondry p-0 m-0'
                            onClick={() => handleDownload(file.name)}
                          >
                            <img src={downloadIcon} alt='Download' />
                          </button>

                          <button
                            className='btn btn-secondry p-0 m-0'
                            onClick={() => {
                              setDocumentId(file.documentId)
                              setDeleteShowModal(true)
                            }}
                          >
                            <img src={deleteIcon} alt='Delete' />
                          </button>
                        </div>
                      </li>
                    </>
                  ))}
                </ul>
              </div>
            )}
          </div>
          {!loading && files?.length === 0 ? <NoDataPage /> : <div></div>}

          <ViewDocModal
            isActive={isActive}
            setIsActive={setIsActive}
            handleIsActive={handleIsActive}
            fileName={selectedFileName}
          />

          <FileUpload
            fileSize={parseInt(process.env.REACT_APP_STAKEHOLDERS_MAX_FILE_SIZE!)}
            maxFileNumber={10}
            allowType={allowedFileTypes}
            metaData={{module: 'document', isProtected: false}}
            modalStatus={modelStatus}
            handleClose={() => setModelStatus(false)}
            handleSuccess={(id: number, name: string) => {
              console.log(id, name)
              setFiles((prevFiles: any) => [...prevFiles, {id, name}])
              onCreateDocument(id)
            }}
            resourceType='all'
          />
        </div>
      </>
      <DeleteFileConfirmationModal
        setDeleteShowModal={setDeleteShowModal}
        showDeleteModal={showDeleteModal}
        onDeleteSubmit={deleteFile}
        deleteLoading={deleteLoading}
        header='Delete File'
        paragraph='Are you sure you want to delete this file?'
      />
    </>
  )
}
